<template>
  <div class="split-content-container">
    <div class="left">
      <template v-if="beatData.slideUp">
        <SlideUpText v-if="visible" :text="beatData.copy" />
      </template>
      <template v-else>
        {{ beatData.copy }}
      </template>
    </div>
    <div class="right">
      <div class="background" :style="`background-image:url(${beatData.bgImageRight || ''})`">
        <video v-if="beatData.videoRight" :src="beatData.videoRight" muted loop ref="video"></video>
      </div>
    </div>
  </div>
</template>

<script>
import SlideUpText from '@/components/SlideUpText'

export default {
  props: {
    beatData: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SlideUpText
  },
  watch: {
    visible: function(val) {
      if (val) {
        this.playVideo()
      } else {
        this.stopVideo()
      }
    }
  },
  methods: {
    playVideo () {
      let target = this.$refs['video']
      if (target) {
        target.muted = false
        target.play()
      }
    },
    stopVideo () {
      let target = this.$refs['video']
      if (target) {
        target.pause()
        target.muted = true
        target.currentTime = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

.split-content-container {
  height: 100%;
  height: -webkit-fill-available;
  .left, .right {
    position: relative;
    height: 100%;
    height: -webkit-fill-available;
    display: inline-block;
    vertical-align: top;
    width: 50%;

    @include media($bp-tablet) {
      height: 50%;
    }
  }
  .left {
    z-index: 1;
    padding: $space-xl $space-l $space-l $space-xxl;
    // font-size: $font-size-l;
    font-size: 4vw;
    line-height: 1.05em;
    @include media($bp-desktop-xl) {
      padding: $space-xl $space-ml $space-ml;
    }
    @include media($bp-desktop-l) {
      // width: 60%;
    }
    @include media($bp-desktop-s) {
      // font-size: $font-size-ml;
    }
    @include media($bp-tablet) {
      width: 100%;
      padding: $space-l $space-s $space-s;
      font-size: $font-size-m;
    }
  }
  .right {
    background-color: white;
    @include media($bp-desktop-l) {
      // width: 40%;
    }
    @include media($bp-tablet) {
      width: 100%;
    }

    .background {
      @include bg-cover-center;
      position: absolute;
      right: 0;
      height: 100%;
      width: 150%;

      @include media($bp-tablet) {
        width: 100%;
      }
    }

    video {
      @include center-in-parent;
      width: 50%;
      max-width: 400px;
    }
  }
}
</style>